export default __webpack_public_path__ + "static/media/icons-workflow-management.986a650a.svg";